export const fontTheme = {
  fontFamily: "'RedHatDisplayRegular'",
};
